'use client';

import { useTranslations } from 'next-intl';
import {
  Conditional,
  HeaderStoreLocationButton
} from 'components/pcc-components';
import { useStoreInfoDrawer } from '../../store-info-drawer-context';
import { useAssociatedDealer } from 'components/associated-dealers/associated-dealer-context';
import usePathContains from 'hooks/use-path-contains';
interface StoreAccountButtonProps {
  isDealerUser: boolean;
}

export const StoreAccountButton = ({
  isDealerUser
}: StoreAccountButtonProps) => {
  const t = useTranslations();
  const storeInfoDrawer = useStoreInfoDrawer();
  const { associatedDealerDrawer } = useAssociatedDealer();
  const { checkPathHas } = usePathContains();
  const { checkPathExactHas } = usePathContains();

  const changeAccountLabel = t('CHANGE_ADP_CSP_CUST');
  const handleClick = () => {
    storeInfoDrawer.closeDrawer();
    associatedDealerDrawer.openDrawer();
  };
  return (
    <Conditional
      test={
        isDealerUser ||
        (!checkPathExactHas('cart') && !checkPathHas('/confirmation'))
      }
      fallback={null}
    >
      <HeaderStoreLocationButton
        label={changeAccountLabel}
        onClick={handleClick}
      />
    </Conditional>
  );
};
